const notifyLike = () => {
	app.notify.append({
		id: 'notify-uikit-default',
		content:
			`
				<i class="icon icon-like"></i>
				<h3>Товар добавлен в избранное</h3>
				<p>Можете найти его в личном кабинете</p>
				<button type="button" class="button button--text button--size--tiny">
					Перейти в подписки
					<i class="icon icon-arrow-small-right"></i>
				</button>
			`,
	});
};

const notifyComparison = () => {
	app.notify.append({
		id: 'notify-uikit-default',
		content:
			`
				<i class="icon icon-comparison"></i>
				<h3>Товар добавлен в сравнение</h3>
				<p>Можете найти его в личном кабинете</p>
				<button type="button" class="button button--text button--size--tiny">
					Перейти в сравнение
					<i class="icon icon-arrow-small-right"></i>
				</button>
			`,
	});
};

const notifySubscribe = () => {
	app.notify.append({
		id: 'notify-uikit-default',
		content:
			`
				<i class="icon icon-notification"></i>
				<h3>Вы подписались на товар</h3>
				<p>Мы оповестим вас, когда товар появится на складе</p>
				<button type="button" class="button button--text button--size--tiny">
					Перейти в подписки
					<i class="icon icon-arrow-small-right"></i>
				</button>
			`,
	});
};

export { notifyLike, notifyComparison, notifySubscribe };
